import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { FulfillmentTrackingUpdateWithinState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/fulfillment-tracking-update-within";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const FulfillmentTrackingUpdateWithinDetails = memo(
  function FulfillmentTrackingUpdateWithinDetails({
    state,
    setState,
    disabled,
  }: ConditionTypeDetailsProps<FulfillmentTrackingUpdateWithinState>) {
    return (
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Max days
        </Text>
        <RedoTextInput
          min={0}
          onBlur={() => setState((+state).toFixed(0))}
          placeholder="Enter number of days..."
          setValue={setState}
          state={disabled ? "readonly" : "default"}
          value={state}
        />
      </Flex>
    );
  },
);
